var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTrashIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.99862 9.2102e-05C8.86615 -0.00170569 8.73465 0.0228318 8.61175 0.0722798C8.48885 0.121728 8.37699 0.195101 8.28269 0.288137C8.18838 0.381174 8.11349 0.492021 8.06238 0.61424C8.01127 0.736459 7.98495 0.867616 7.98495 1.00009H1.99862C1.86611 0.998218 1.73454 1.0227 1.61157 1.07211C1.48861 1.12153 1.37669 1.19489 1.28232 1.28793C1.18795 1.38098 1.11301 1.49185 1.06186 1.61411C1.01071 1.73636 0.984375 1.86757 0.984375 2.00009C0.984375 2.13262 1.01071 2.26382 1.06186 2.38608C1.11301 2.50834 1.18795 2.61921 1.28232 2.71225C1.37669 2.8053 1.48861 2.87866 1.61157 2.92807C1.73454 2.97748 1.86611 3.00197 1.99862 3.00009H19.9986C20.1311 3.00197 20.2627 2.97748 20.3857 2.92807C20.5086 2.87866 20.6206 2.8053 20.7149 2.71225C20.8093 2.61921 20.8842 2.50834 20.9354 2.38608C20.9865 2.26382 21.0129 2.13262 21.0129 2.00009C21.0129 1.86757 20.9865 1.73636 20.9354 1.61411C20.8842 1.49185 20.8093 1.38098 20.7149 1.28793C20.6206 1.19489 20.5086 1.12153 20.3857 1.07211C20.2627 1.0227 20.1311 0.998218 19.9986 1.00009H14.0123C14.0123 0.867616 13.986 0.736459 13.9349 0.61424C13.8837 0.492021 13.8089 0.381174 13.7145 0.288137C13.6202 0.195101 13.5084 0.121728 13.3855 0.0722798C13.2626 0.0228318 13.1311 -0.00170569 12.9986 9.2102e-05H8.99862ZM1.99862 5.00009V21.0001C1.99862 22.1051 2.89362 23.0001 3.99862 23.0001H17.9986C19.1036 23.0001 19.9986 22.1051 19.9986 21.0001V5.00009H1.99862Z",
    fill: "#DC3545"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashIcon);
export default __webpack_public_path__ + "static/media/trash-icon.c3ecf98ba359c698afba8d386bd81706.svg";
export { ForwardRef as ReactComponent };